import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {TokenService} from '../modules/authentication/services';
import {LOGIN_ROUTE} from '@core/constants/navigation/navigation.const';

@Injectable()
export class AuthGuard  {
  constructor(
    private router: Router,
    private token: TokenService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.token.isToken) {
      return true;
    }

    this.router.navigateByUrl(LOGIN_ROUTE, /* Removed unsupported properties by Angular migration: queryParams. */ {});
    return false;
  }
}
